module.exports = __webpack_public_path__ + "img/sign_250460827_1.ff46f420.png";